module.exports = "/images/o-logo-white.svg?265c2fcb8dcca5f0180e4b26d8886eea";